import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Box,
  Typography,
  Grid,
  Paper,
  Select,
  MenuItem,
} from "@mui/material";
import { dateDifference, formatDateText } from "../CommonFunctions";
import { CheckinForm } from "../CheckinForm";
import { useState } from "react";
import { ThreeDayNoticeForm } from "../ThreeDayNoticeForm";

export default function BookingOverview({tenancyId, tenancyDetails, customersDetails}) {

  const [showCheckinForm, setShowCheckinForm] = useState(false);
  const [showThreeDayNotice, setShowThreeDayNotice] = useState(false);

  const handleFormChange = (e) => {
  const value = e.target.value;

  if (value === "checkin") {
    setShowCheckinForm(true);
  }

  if (value === "threeDayNotice") {
    setShowThreeDayNotice(true);
  }
};


    
  
  return (
    <>
      {/* TOP BOOKING OVERVIEW TABLE */}
      <Box px={4}>
        <TableContainer sx={{ boxShadow: "none", bgcolor: "#f7f7f7" }}>
          <Table
            sx={{
              "& td, & th": { border: "none", paddingY: 2, paddingX: 4 },
              "& thead th": { paddingBottom: "2px" },
              "& tbody td": { paddingTop: "2px" },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell>Room</TableCell>
                <TableCell>Booking ID</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Checkin Date</TableCell>
                <TableCell>Checkout Date</TableCell>
                <TableCell>Duration</TableCell>
                <TableCell>Forms</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              <TableRow>
                <TableCell>{tenancyDetails.roomid}</TableCell>
                <TableCell>{tenancyId}</TableCell>
                <TableCell
                  style={{
                    color:
                      tenancyDetails.status === "active"
                        ? "green"
                        : tenancyDetails.status === "checked-out"
                        ? "red"
                        : "inherit",
                    fontWeight: 600
                  }}
                >
                  {tenancyDetails.status || "—"}
                </TableCell>

                <TableCell><b>{formatDateText(tenancyDetails.checkin)}</b></TableCell>
                <TableCell><b>{formatDateText(tenancyDetails.checkout)}</b></TableCell>
                <TableCell><b>{dateDifference(tenancyDetails.checkin,tenancyDetails.checkout)} days</b></TableCell>
                <TableCell><Select
                    size="small"
                    defaultValue="none"
                    sx={{  minWidth: 130, height:25 }}
                    onChange={handleFormChange}
                  >
                    <MenuItem value="none">Select Forms</MenuItem>
                    <MenuItem value="checkin" >Checkin Form</MenuItem>
                    <MenuItem value="threeDayNotice">Three Day Notice</MenuItem>
                  </Select></TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      {showCheckinForm && <CheckinForm
        value={{isCheckinFormVisible: showCheckinForm, 
          tenancyDetails, customersDetails}}  
        setIsCheckinFormVisible={setShowCheckinForm}
      />}
      {showThreeDayNotice && <ThreeDayNoticeForm
        value={{
          isCheckinFormVisible: showCheckinForm, 
          tenancyDetails, customersDetails
          
        }}
        setIsThreeDayNoticeFormVisible={setShowThreeDayNotice}
      /> }

    
    </>
  );
}
